export default (_, t, __, appState) => {
  return {
    fields: [
      {
        type: 'group',
        label: t('propsEditor.setBrushStyle'),
        children: [
          // 取消翻译笔刷的模式不要显示笔刷颜色，因为取消翻译笔刷的模式下，笔刷颜色是透明的，无法显示
          ...(appState.isDraw2CancelTransMode || appState.isAiInpaintMode
            ? []
            : [
                {
                  as: 'color',
                  label: t('propsEditor.brushColor'),
                  name: 'brushColor',
                  descriptions: [t('propsEditor.rectBackgroundColorTip')],
                },
              ]),
          {
            as: 'slider',
            label: t('propsEditor.brushWidth'),
            blockLabel: true,
            name: 'brushWidth',
            min: 1,
            descriptions: [t('propsEditor.brushWidthTip')],
          },
        ],
      },
    ],
  };
};
